"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PageUrlHelper_1 = __importDefault(require("@react/web/Listing/PageUrlHelper/PageUrlHelper"));
const MergedCarListingOfferListItemMobileView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/MergedCarListingOfferListItemMobileView"));
const MergedCarListingOfferListItemDesktopView_1 = __importDefault(require("@react/web/Listing/ListingOffersList/CarListingItem/views/MergedCarListingOfferListItemDesktopView"));
const PageHelper_1 = __importDefault(require("@react/web/Listing/PageHelper/PageHelper"));
const MergedCarListingOfferListItemView = ({ handleClick, isWebpSupported, listingOffer, simpleOffer, isListingOffersListEmpty, isSmallScreen, }) => {
    const contractLengths = listingOffer.simpleOfferList.getContractLengthString();
    const mileage = listingOffer.simpleOfferList.getMileageString();
    const mostExpensiveSimpleOffer = listingOffer.simpleOfferList.getMostExpensiveSimpleOffer();
    const imageThumb = isWebpSupported && mostExpensiveSimpleOffer.image.hasWebpImage && mostExpensiveSimpleOffer.image.thumbWebp
        ? mostExpensiveSimpleOffer.image.thumbWebp
        : mostExpensiveSimpleOffer.image.thumb;
    const imageMedium = isWebpSupported && mostExpensiveSimpleOffer.image.hasWebpImage && mostExpensiveSimpleOffer.image.mediumWebp
        && mostExpensiveSimpleOffer.image.hasWebpImage
        && mostExpensiveSimpleOffer.image.mediumWebp
        ? mostExpensiveSimpleOffer.image.mediumWebp
        : mostExpensiveSimpleOffer.image.medium;
    const gtmClass = 'gtm-dk-car-offer-card-link';
    const cheapestPriceOffer = listingOffer.simpleOfferList.getCheapestSimpleOffer().priceOfferList.getCheapestPriceOffer();
    let offerUrl;
    if (isListingOffersListEmpty === true) {
        offerUrl = PageUrlHelper_1.default.getCarListingMergedOfferUrlWithoutFilters(listingOffer);
    }
    else {
        offerUrl = PageUrlHelper_1.default.getCarListingMergedOfferUrl(listingOffer);
    }
    const minEnginePower = Math.min(...listingOffer.simpleOfferList.simpleOffers.map((offer) => offer.powertrain.enginePowerKw));
    const maxEnginePower = Math.max(...listingOffer.simpleOfferList.simpleOffers.map((offer) => offer.powertrain.enginePowerKw));
    const uniqueTrimNames = listingOffer.simpleOfferList.getUniqueTrimNames();
    const handleOnClick = (event) => {
        if (PageHelper_1.default.shouldOpenInNewTab(event) === true) {
            return;
        }
        event.preventDefault();
        handleClick(listingOffer, isListingOffersListEmpty);
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        isSmallScreen === true
            && react_1.default.createElement(MergedCarListingOfferListItemMobileView_1.default, { listingOffer: listingOffer, offerUrl: offerUrl, gtmClass: gtmClass, simpleOffer: simpleOffer, contractLengths: contractLengths, mileage: mileage, imageThumb: imageThumb, imageMedium: imageMedium, cheapestPriceOffer: cheapestPriceOffer, minEnginePower: minEnginePower, maxEnginePower: maxEnginePower, handleClick: handleOnClick }),
        isSmallScreen === false
            && react_1.default.createElement(MergedCarListingOfferListItemDesktopView_1.default, { listingOffer: listingOffer, offerUrl: offerUrl, gtmClass: gtmClass, simpleOffer: simpleOffer, contractLengths: contractLengths, mileage: mileage, imageThumb: imageThumb, imageMedium: imageMedium, cheapestPriceOffer: cheapestPriceOffer, minEnginePower: minEnginePower, maxEnginePower: maxEnginePower, uniqueTrimNames: uniqueTrimNames, handleClick: handleOnClick }));
};
exports.default = MergedCarListingOfferListItemView;
